import { api } from './api'

/** SessionStorage: nach Schüler-Login gesetzt — Diagramm-Auswertung beim Logout entfernen */
export const EVIDENCE_CHART_LOGIN_CHECK_KEY = 'lr_evidence_chart_login_check'

export interface EvidenceChartAnalysisPayload {
  analysis: string | null
  generatedAt: string | null
  isStale: boolean
  staleAfterDays: number
  featureEnabled: boolean
  llmAvailable: boolean
  profileDisabled?: boolean
}

export async function fetchEvidenceChartAnalysis(
  subject: string,
  includeClassAverage: boolean
): Promise<EvidenceChartAnalysisPayload> {
  const params = new URLSearchParams()
  params.set('subject', subject)
  params.set('includeClassAverage', includeClassAverage ? 'true' : 'false')
  const response = await api.get(`/student/evidence-chart-analysis?${params.toString()}`)
  const payload = response.data as { success: boolean; data: EvidenceChartAnalysisPayload }
  if (!payload.success || !payload.data) {
    throw new Error('Auswertung konnte nicht geladen werden.')
  }
  return payload.data
}
